module.exports = __webpack_public_path__ + "img/1.1627595b.jpg";